import MoreVertMenu from './MoreVertMenu'
export default MoreVertMenu



// WEBPACK FOOTER //
// ./src/routes/MoreVertMenu/index.js